exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".h4-style {\n  color: #E70E02;\n  font-size: 20px;\n  font-family: 'Inter', sans-serif; }\n\n.h3-style {\n  color: #E70E02;\n  font-size: 25px;\n  font-family: 'Inter', sans-serif; }\n\n.pokemon-border {\n  background-color: #F5F5DC;\n  border-radius: 10px;\n  border: 2px purple solid;\n  box-shadow: 10px 10px 10px silver;\n  margin: 10px;\n  padding: 25px; }\n\n.button-style {\n  background-color: #ffcccb;\n  cursor: pointer;\n  padding: 4px 8px;\n  margin: 4px 2px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/PokemonUpdate/PokemonUpdate.styles.scss
// module id = 222
// module chunks = 0